// import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// import Ico from './iconBox';

// import client1 from '../assets/images/client (1).jpg';
// import client2 from '../assets/images/client (2).jpg';
// import client3 from '../assets/images/client (3).jpg';
// import client4 from '../assets/images/client (4).jpg';
// import client5 from '../assets/images/client (5).jpg';
// import client6 from '../assets/images/client (6).jpg';
// import client7 from '../assets/images/client (7).jpg';

// // import person1 from '../assets/images/person_1.jpg';
// // import person2 from '../assets/images/person_2.jpg';
// // import person3 from '../assets/images/person_3.jpg';
// // import person4 from '../assets/images/person_4.jpg';

// class About extends Component {
//     state = {

//     }
//     componentDidMount(){
//         window.scrollTo(0, 0)

//     }
//     render() {
//         return (
//             <div>
            
//             {/* End Main Top */}
//             {/* Start Top Search */}
            
//             {/* End Top Search */}
//             {/* Start All Title Box */}
            
//             {/* End All Title Box */}
//             {/* Start About Page  */}





//             <div className="page-header text-center" style={{backgroundImage: 'url("assets/images/page-header-bg.jpg")'}}>
//             <div className="container">
//               <h1 className="page-title">Client</h1>
//             </div>{/* End .container */}
//           </div>{/* End .page-header */}
//           <nav aria-label="breadcrumb" className="breadcrumb-nav mb-2">
//             <div className="container">
//               <ol className="breadcrumb">
//                 <li className="breadcrumb-item"><a href="index-32.html">Home</a></li>
//                 <li className="breadcrumb-item"><a >Our Client</a></li>
//               </ol>
//             </div>{/* End .container */}
//           </nav>{/* End .breadcrumb-nav */}



        

// <div className='container-fuild' style={{margin : "30px auto"}}>
//             <div className='row'  >
//             <div className="col-lg-2 col-sm-12" style={{margin  :"auto"}}>
//                 <img src={client1} alt="" />
//             </div>
//             <div className="col-lg-2 col-sm-12" style={{margin  :"auto"}}>
//                 <img src={client2} alt="" />
//             </div>
//             <div className="col-lg-2 col-sm-12" style={{margin  :"auto"}}>
//                 <img src={client3} alt="" />
//             </div>
//             <div className="col-lg-2 col-sm-12" style={{margin  :"auto"}}>
//                 <img src={client4} alt="" />
//             </div>
//             <div className="col-lg-2 col-sm-12" style={{margin  :"auto"}}>
//                 <img src={client5} alt="" />
//             </div>
//             <div className="col-lg-2 col-sm-12" style={{margin  :"auto"}}>
//                 <img src={client6} alt="" />
//             </div>
//             <div className="col-lg-2 col-sm-12" style={{margin  :"auto"}}>
//                 <img src={client7} alt="" />
//             </div>
//             </div>
//             </div>


          


//             {/* </div> */}
        
//           </div>
//         )
//     }
// }

// export default About;











import React, { useState } from "react";








import AfoltLogo from "../assets/images/Afolt logo.png";
import AseelHoldings from "../assets/images/aseel holdings libya project.jfif";
import CharlesKeithLogo from "../assets/images/charles and keith logo.png";
import ClubPadelLogo from "../assets/images/Club padel logo.png";
import CpdLogo from "../assets/images/cpd logo.png";
import ElectroscanLogo from "../assets/images/Electroscan logo.jfif";
import FairmountHotelLogo from "../assets/images/Fair mount hotel logo.jfif";
import FujairahOilLogo from "../assets/images/fujairah oil terminal logo.png";
import GreenGroupLogo from "../assets/images/Green Group logo.jfif";
import HamptonHiltonLogo from "../assets/images/hampton By hilton logo.png";
import HiltonLogo from "../assets/images/Hilton.png";
import HolcimLogo from "../assets/images/holcim logo.jfif";
import HolidayInnLogo from "../assets/images/Holiday in logo.jfif";
import HydeWalkLogo from "../assets/images/Hyde walk logo.png";
import JvcLogo from "../assets/images/Jvc logo.png";
import LamprellEnergyLogo from "../assets/images/Lamprell energy logo.png";
import MarriottLogo from "../assets/images/marriot.jfif";
import QGardensLogo from "../assets/images/Q gardens logo.png";
import RasAlKhaimahLogo from "../assets/images/Raisalkhaimah logo.png";
import SctChemicalsLogo from "../assets/images/sct chemicals logo.jfif";




const ClientProjects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  /*
  =====================================================
  CLIENT PROJECTS DATA
  اپنی client images یہاں replace کریں
  =====================================================
  */
const projects = [
  {
    id: 1,
    image: AfoltLogo,
    title: "AFOLT",
    location: "UAE",
    service: "Landscaping & Garden Services",
    description:
      "Professional landscaping and garden maintenance services delivered for AFOLT.",
  },

  {
    id: 2,
    image: AseelHoldings,
    title: "Aseel Holdings Libya Project",
    location: "Libya",
    service: "Landscaping Project",
    description:
      "A complete landscaping project delivered for Aseel Holdings.",
  },

  {
    id: 3,
    image: CharlesKeithLogo,
    title: "Charles & Keith",
    location: "UAE",
    service: "Landscaping Services",
    description:
      "Professional landscaping and outdoor maintenance services for Charles & Keith.",
  },

  {
    id: 4,
    image: ClubPadelLogo,
    title: "Club Padel",
    location: "Dubai, UAE",
    service: "Landscape Maintenance",
    description:
      "Landscape and outdoor maintenance services for Club Padel.",
  },

  {
    id: 5,
    image: CpdLogo,
    title: "CPD",
    location: "UAE",
    service: "Landscaping Services",
    description:
      "Professional landscaping services and outdoor maintenance for CPD.",
  },

  {
    id: 6,
    image: ElectroscanLogo,
    title: "Electroscan",
    location: "UAE",
    service: "Landscape Services",
    description:
      "Professional garden and landscape services provided for Electroscan.",
  },

  {
    id: 7,
    image: FairmountHotelLogo,
    title: "Fairmont Hotel",
    location: "Dubai, UAE",
    service: "Hotel Landscaping",
    description:
      "Professional landscaping and garden maintenance services for Fairmont Hotel.",
  },

  {
    id: 8,
    image: FujairahOilLogo,
    title: "Fujairah Oil Terminal",
    location: "Fujairah, UAE",
    service: "Commercial Landscaping",
    description:
      "Commercial landscaping and outdoor maintenance services for Fujairah Oil Terminal.",
  },

  {
    id: 9,
    image: GreenGroupLogo,
    title: "Green Group",
    location: "UAE",
    service: "Landscaping Services",
    description:
      "Professional landscaping and garden maintenance services for Green Group.",
  },

  {
    id: 10,
    image: HamptonHiltonLogo,
    title: "Hampton by Hilton",
    location: "UAE",
    service: "Hotel Landscaping",
    description:
      "Landscape and garden maintenance services provided for Hampton by Hilton.",
  },

  {
    id: 11,
    image: HiltonLogo,
    title: "Hilton",
    location: "UAE",
    service: "Hotel Landscaping",
    description:
      "Professional landscaping and outdoor maintenance services for Hilton.",
  },

  {
    id: 12,
    image: HolcimLogo,
    title: "Holcim",
    location: "UAE",
    service: "Commercial Landscaping",
    description:
      "Professional commercial landscaping and outdoor maintenance services for Holcim.",
  },

  {
    id: 13,
    image: HolidayInnLogo,
    title: "Holiday Inn",
    location: "UAE",
    service: "Hotel Landscaping",
    description:
      "Professional garden and landscape maintenance services for Holiday Inn.",
  },

  {
    id: 14,
    image: HydeWalkLogo,
    title: "Hyde Walk",
    location: "Dubai, UAE",
    service: "Landscape Services",
    description:
      "Professional landscaping and outdoor maintenance services for Hyde Walk.",
  },

  {
    id: 15,
    image: JvcLogo,
    title: "JVC",
    location: "Dubai, UAE",
    service: "Community Landscaping",
    description:
      "Professional landscaping and garden maintenance services in JVC.",
  },

  {
    id: 16,
    image: LamprellEnergyLogo,
    title: "Lamprell Energy",
    location: "UAE",
    service: "Commercial Landscaping",
    description:
      "Professional landscaping and outdoor maintenance services for Lamprell Energy.",
  },

  {
    id: 17,
    image: MarriottLogo,
    title: "Marriott",
    location: "UAE",
    service: "Hotel Landscaping",
    description:
      "Premium landscaping and garden maintenance services for Marriott.",
  },

  {
    id: 18,
    image: QGardensLogo,
    title: "Q Gardens",
    location: "Dubai, UAE",
    service: "Garden Landscaping",
    description:
      "Professional garden design, landscaping and maintenance services for Q Gardens.",
  },

  {
    id: 19,
    image: RasAlKhaimahLogo,
    title: "Ras Al Khaimah",
    location: "Ras Al Khaimah, UAE",
    service: "Landscaping Services",
    description:
      "Professional landscaping and outdoor maintenance services in Ras Al Khaimah.",
  },

  {
    id: 20,
    image: SctChemicalsLogo,
    title: "SCT Chemicals",
    location: "UAE",
    service: "Commercial Landscaping",
    description:
      "Commercial landscaping and garden maintenance services for SCT Chemicals.",
  },
];


  /*
  =====================================================
  WHATSAPP
  =====================================================
  */

  const whatsappNumber = "971509480695";

  const whatsappMessage = encodeURIComponent(
    "Hello, I saw your landscaping projects and would like to get a quote."
  );

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <>
      {/* =================================================
          CLIENT PROJECTS SECTION
      ================================================= */}

      <section className="client-project-section">

        <div className="client-project-container">

          {/* =================================================
              SECTION HEADING
          ================================================= */}

          <div className="client-project-heading">

            <span className="client-project-subtitle">
              OUR CLIENTS
            </span>

            <h2>
              Our Recent Projects
            </h2>

            <p>
              Explore some of our recent landscaping and garden
              projects completed for our valued clients across Dubai.
            </p>

          </div>


          {/* =================================================
              PROJECT GRID
          ================================================= */}

          <div className="client-project-grid">

            {projects.map((project) => (

              <div
                className="client-project-card"
                key={project.id}
                onClick={() => setSelectedProject(project)}
              >

                {/* IMAGE */}

                <img
                  src={project.image}
                  alt={project.title}
                  className="client-project-image"
                />


                {/* DARK OVERLAY */}

                <div className="client-project-overlay">

                  <div className="client-project-overlay-content">

                    <span className="client-project-service">
                      {project.service}
                    </span>

                    <h3>
                      {project.title}
                    </h3>

                    <p>
                      {project.location}
                    </p>

                    <button
                      type="button"
                      className="client-view-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedProject(project);
                      }}
                    >
                      View Project
                      <span>→</span>
                    </button>

                  </div>

                </div>

              </div>

            ))}

          </div>


          {/* =================================================
              BOTTOM CTA
          ================================================= */}

          <div className="client-project-cta">

            <div className="client-project-cta-content">

              <div>
                <span>
                  HAVE A PROJECT IN MIND?
                </span>

                <h3>
                  Let's Create Your Dream Garden
                </h3>
              </div>


              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="client-quote-button"
              >
                Get a Free Quote
                <span>→</span>
              </a>

            </div>

          </div>

        </div>

      </section>


      {/* =================================================
          PROJECT MODAL
      ================================================= */}

      {selectedProject && (

        <div
          className="project-modal-overlay"
          onClick={() => setSelectedProject(null)}
        >

          <div
            className="project-modal"
            onClick={(e) => e.stopPropagation()}
          >

            {/* CLOSE BUTTON */}

            <button
              type="button"
              className="project-modal-close"
              onClick={() => setSelectedProject(null)}
            >
              ×
            </button>


            {/* MODAL IMAGE */}

            <div className="project-modal-image-wrapper">

              <img
                src={selectedProject.image}
                alt={selectedProject.title}
                className="project-modal-image"
              />

            </div>


            {/* MODAL CONTENT */}

            <div className="project-modal-content">

              <span className="project-modal-service">
                {selectedProject.service}
              </span>

              <h2>
                {selectedProject.title}
              </h2>

              <div className="project-modal-location">
                📍 {selectedProject.location}
              </div>

              <p>
                {selectedProject.description}
              </p>


              {/* MODAL CTA */}

              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="project-modal-button"
              >
                Get a Quote
                <span>→</span>
              </a>

            </div>

          </div>

        </div>

      )}


      {/* =================================================
          CSS
      ================================================= */}

      <style>
        {`

        /* =================================================
           MAIN SECTION
        ================================================= */

        .client-project-section {
          width: 100%;

          padding: 20px 20px;

          background: #ffffff;
        }


        .client-project-container {
          width: 100%;

          max-width: 1200px;

          margin: 0 auto;
        }


        /* =================================================
           HEADING
        ================================================= */

        .client-project-heading {
          max-width: 720px;

          margin: 0 auto 50px;

          text-align: center;
        }


        .client-project-subtitle {
          display: inline-block;

          margin-bottom: 12px;

          color: #4b8b3b;

          font-size: 13px;

          font-weight: 700;

          letter-spacing: 3px;

          text-transform: uppercase;
        }


        .client-project-heading h2 {
          margin: 0 0 15px;

          color: #222222;

          font-size: 44px;

          line-height: 1.2;

          font-weight: 700;
        }


        .client-project-heading p {
          margin: 0;

          color: #777777;

          font-size: 16px;

          line-height: 1.7;
        }


        /* =================================================
           PROJECT GRID
        ================================================= */

        .client-project-grid {
          width: 100%;

          display: grid;

          grid-template-columns:
            repeat(3, 1fr);

          gap: 24px;
        }


        /* =================================================
           PROJECT CARD
        ================================================= */

        .client-project-card {
          position: relative;

          width: 100%;

          height: 360px;

          overflow: hidden;

          border-radius: 14px;

          background: #eeeeee;

          cursor: pointer;

          box-shadow:
            0 5px 20px rgba(0, 0, 0, 0.06);

          transition:
            transform 0.4s ease,
            box-shadow 0.4s ease;
        }


        .client-project-card:hover {
          transform: translateY(-5px);

          box-shadow:
            0 15px 35px rgba(0, 0, 0, 0.13);
        }


        /* =================================================
           IMAGE
        ================================================= */

        .client-project-image {
          width: 100%;

          height: 100%;

          object-fit: none;

          display: block;

          transition:
            transform 0.7s ease;
        }


        .client-project-card:hover
        .client-project-image {
          transform: scale(1.08);
        }


        /* =================================================
           OVERLAY
        ================================================= */

        .client-project-overlay {
          position: absolute;

          inset: 0;

          display: flex;

          align-items: flex-end;

          padding: 28px;

          background:
            linear-gradient(
              to top,
              rgba(0, 0, 0, 0.85) 0%,
              rgba(0, 0, 0, 0.48) 45%,
              rgba(0, 0, 0, 0.05) 100%
            );

          opacity: 0;

          transition:
            opacity 0.4s ease;
        }


        .client-project-card:hover
        .client-project-overlay {
          opacity: 1;
        }


        /* =================================================
           OVERLAY CONTENT
        ================================================= */

        .client-project-overlay-content {
          width: 100%;

          transform:
            translateY(20px);

          transition:
            transform 0.4s ease;
        }


        .client-project-card:hover
        .client-project-overlay-content {
          transform:
            translateY(0);
        }


        .client-project-service {
          display: block;

          margin-bottom: 7px;

          color: #bfe5b5;

          font-size: 11px;

          font-weight: 700;

          letter-spacing: 1.5px;

          text-transform: uppercase;
        }


        .client-project-overlay h3 {
          margin: 0 0 6px;

          color: #ffffff;

          font-size: 22px;

          line-height: 1.3;

          font-weight: 600;
        }


        .client-project-overlay p {
          margin: 0 0 17px;

          color: #eeeeee;

          font-size: 13px;
        }


        /* =================================================
           VIEW PROJECT BUTTON
        ================================================= */

        .client-view-button {
          display: inline-flex;

          align-items: center;

          gap: 9px;

          padding: 9px 16px;

          color: #ffffff;

          background: #4b8b3b;

          border: 1px solid #4b8b3b;

          border-radius: 25px;

          font-size: 12px;

          font-weight: 600;

          cursor: pointer;

          transition:
            all 0.3s ease;
        }


        .client-view-button span {
          font-size: 17px;

          transition:
            transform 0.3s ease;
        }


        .client-view-button:hover {
          color: #4b8b3b;

          background: #ffffff;
        }


        .client-view-button:hover span {
          transform:
            translateX(4px);
        }


        /* =================================================
           CTA SECTION
        ================================================= */

        .client-project-cta {
          margin-top: 45px;

          padding: 30px 35px;

          background:
            linear-gradient(
              135deg,
              #365f2d,
              #4b8b3b
            );

          border-radius: 14px;

          box-shadow:
            0 10px 30px
            rgba(75, 139, 59, 0.18);
        }


        .client-project-cta-content {
          display: flex;

          align-items: center;

          justify-content: space-between;

          gap: 25px;
        }


        .client-project-cta-content > div span {
          display: block;

          margin-bottom: 6px;

          color: #cce8c3;

          font-size: 11px;

          font-weight: 700;

          letter-spacing: 2px;
        }


        .client-project-cta h3 {
          margin: 0;

          color: #ffffff;

          font-size: 25px;

          font-weight: 600;
        }


        /* =================================================
           QUOTE BUTTON
        ================================================= */

        .client-quote-button {
          display: inline-flex;

          align-items: center;

          justify-content: center;

          gap: 10px;

          flex-shrink: 0;

          padding: 13px 23px;

          color: #4b8b3b !important;

          background: #ffffff;

          border: 2px solid #ffffff;

          border-radius: 30px;

          font-size: 13px;

          font-weight: 700;

          text-decoration: none !important;

          transition:
            all 0.3s ease;
        }


        .client-quote-button:hover {
          color: #ffffff !important;

          background: transparent;

          transform:
            translateY(-2px);

          text-decoration: none !important;
        }


        .client-quote-button span {
          font-size: 18px;

          transition:
            transform 0.3s ease;
        }


        .client-quote-button:hover span {
          transform:
            translateX(4px);
        }


        /* =================================================
           MODAL OVERLAY
        ================================================= */

        .project-modal-overlay {
          position: fixed;

          inset: 0;

          z-index: 99999;

          display: flex;

          align-items: center;

          justify-content: center;

          padding: 20px;

          background:
            rgba(0, 0, 0, 0.72);

          backdrop-filter:
            blur(5px);

          animation:
            modalOverlayAnimation 0.25s ease;
        }


        @keyframes modalOverlayAnimation {

          from {
            opacity: 0;
          }

          to {
            opacity: 1;
          }

        }


        /* =================================================
           MODAL
        ================================================= */

        .project-modal {
          position: relative;

          width: 100%;

          max-width: 900px;

          max-height: 90vh;

          overflow: hidden;

          display: grid;

          grid-template-columns:
            1.1fr 0.9fr;

          background: #ffffff;

          border-radius: 16px;

          box-shadow:
            0 25px 70px
            rgba(0, 0, 0, 0.3);

          animation:
            modalAnimation 0.3s ease;
        }


        @keyframes modalAnimation {

          from {
            opacity: 0;

            transform:
              scale(0.95)
              translateY(15px);
          }

          to {
            opacity: 1;

            transform:
              scale(1)
              translateY(0);
          }

        }


        /* =================================================
           MODAL IMAGE
        ================================================= */

        .project-modal-image-wrapper {
          width: 100%;

          height: 100%;

          min-height: 450px;
        }


        .project-modal-image {
          width: 100%;

          height: 100%;

          min-height: 450px;

          object-fit: cover;

          display: block;
        }


        /* =================================================
           MODAL CONTENT
        ================================================= */

        .project-modal-content {
          padding: 55px 40px;

          display: flex;

          flex-direction: column;

          justify-content: center;
        }


        .project-modal-service {
          display: inline-block;

          margin-bottom: 10px;

          color: #4b8b3b;

          font-size: 12px;

          font-weight: 700;

          letter-spacing: 2px;

          text-transform: uppercase;
        }


        .project-modal-content h2 {
          margin: 0 0 15px;

          color: #222222;

          font-size: 31px;

          line-height: 1.25;

          font-weight: 700;
        }


        .project-modal-location {
          margin-bottom: 20px;

          color: #777777;

          font-size: 14px;
        }


        .project-modal-content p {
          margin: 0 0 25px;

          color: #666666;

          font-size: 14px;

          line-height: 1.8;
        }


        /* =================================================
           MODAL BUTTON
        ================================================= */

        .project-modal-button {
          display: inline-flex;

          align-items: center;

          justify-content: center;

          gap: 10px;

          width: fit-content;

          padding: 13px 23px;

          color: #ffffff !important;

          background: #4b8b3b;

          border: 2px solid #4b8b3b;

          border-radius: 30px;

          font-size: 13px;

          font-weight: 600;

          text-decoration: none !important;

          transition:
            all 0.3s ease;
        }


        .project-modal-button:hover {
          color: #4b8b3b !important;

          background: #ffffff;

          text-decoration: none !important;
        }


        .project-modal-button span {
          font-size: 18px;

          transition:
            transform 0.3s ease;
        }


        .project-modal-button:hover span {
          transform:
            translateX(5px);
        }


        /* =================================================
           CLOSE BUTTON
        ================================================= */

        .project-modal-close {
          position: absolute;

          top: 15px;

          right: 15px;

          z-index: 5;

          width: 38px;

          height: 38px;

          display: flex;

          align-items: center;

          justify-content: center;

          padding: 0;

          color: #333333;

          background: #ffffff;

          border: none;

          border-radius: 50%;

          font-size: 27px;

          line-height: 1;

          cursor: pointer;

          box-shadow:
            0 3px 12px
            rgba(0, 0, 0, 0.15);

          transition:
            all 0.25s ease;
        }


        .project-modal-close:hover {
          color: #ffffff;

          background: #4b8b3b;

          transform:
            rotate(90deg);
        }


        /* =================================================
           TABLET
        ================================================= */

        @media (max-width: 991px) {

          .client-project-section {
            padding: 20px 20px;
          }


          .client-project-heading h2 {
            font-size: 38px;
          }


          .client-project-grid {
            grid-template-columns:
              repeat(2, 1fr);
          }


          .client-project-card {
            height: 330px;
          }


          .project-modal {
            max-width: 750px;
          }


          .project-modal-content {
            padding: 40px 30px;
          }


          .project-modal-content h2 {
            font-size: 26px;
          }

        }


        /* =================================================
           MOBILE
        ================================================= */

        @media (max-width: 767px) {

          .client-project-section {
            padding: 25px 15px;
          }


          .client-project-heading {
            margin-bottom: 30px;
          }


          .client-project-heading h2 {
            font-size: 30px;
          }


          .client-project-heading p {
            font-size: 14px;
          }


          .client-project-grid {
            grid-template-columns: 1fr;

            gap: 18px;
          }


          .client-project-card {
            height: 300px;
          }


          /* Always show overlay on mobile */

          .client-project-overlay {
            opacity: 1;
          }


          .client-project-overlay-content {
            transform: translateY(0);
          }


          .client-project-cta {
            margin-top: 30px;

            padding: 25px 20px;
          }


          .client-project-cta-content {
            flex-direction: column;

            align-items: flex-start;
          }


          .client-project-cta h3 {
            font-size: 21px;
          }


          .client-quote-button {
            width: 100%;
          }


          /* Modal */

          .project-modal {
            display: flex;

            flex-direction: column;

            max-height: 90vh;

            overflow-y: auto;

            border-radius: 12px;
          }


          .project-modal-image-wrapper {
            height: 280px;

            min-height: 280px;
          }


          .project-modal-image {
            height: 280px;

            min-height: 280px;
          }


          .project-modal-content {
            padding: 25px 22px 30px;
          }


          .project-modal-content h2 {
            font-size: 24px;
          }


          .project-modal-content p {
            font-size: 13px;
          }

        }


        /* =================================================
           SMALL MOBILE
        ================================================= */

        @media (max-width: 480px) {

          .client-project-heading h2 {
            font-size: 27px;
          }


          .client-project-card {
            height: 280px;

            border-radius: 10px;
          }


          .client-project-overlay {
            padding: 20px;
          }


          .client-project-overlay h3 {
            font-size: 19px;
          }


          .project-modal-overlay {
            padding: 12px;
          }


          .project-modal-image-wrapper {
            height: 220px;

            min-height: 220px;
          }


          .project-modal-image {
            height: 220px;

            min-height: 220px;
          }


          .project-modal-content {
            padding: 22px 18px 25px;
          }


          .project-modal-content h2 {
            font-size: 21px;
          }

        }

        `}
      </style>
    </>
  );
};

export default ClientProjects;
